(function () {
  const STORAGE_KEY = 'far-afield-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    const wishlistLinks = document.querySelectorAll('a[href*="/pages/wishlist"]');
    const wishlistCountBadges = document.querySelectorAll('.js-wishlist-count');

    wishlistLinks.forEach((link) => {
      if (link.querySelector('.js-wishlist-count')) return;

      if (!link.dataset.wishlistOriginalText) {
        link.dataset.wishlistOriginalText = link.textContent
          .trim()
          .replace(/\s+\(\d+\)$/, '')
          .replace(/\s+\d+$/, '');
      }

      const originalText = link.dataset.wishlistOriginalText || 'Wishlist';

      link.textContent = count > 0 ? `${originalText} (${count})` : originalText;
    });

    wishlistCountBadges.forEach((badge) => {
      if (count > 0) {
        badge.hidden = false;
        badge.textContent = count > 99 ? '(+)' : `(${count})`;
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
  }

  function findItem(productId) {
    return getWishlist().find((item) => String(item.id) === String(productId));
  }

  function addItem(product) {
    const wishlist = getWishlist();
    const exists = wishlist.some((item) => String(item.id) === String(product.id));

    if (!exists) {
      wishlist.push(product);
      saveWishlist(wishlist);
      updateWishlistCount();
    }
  }

  function removeItem(productId) {
    const wishlist = getWishlist().filter((item) => String(item.id) !== String(productId));
    saveWishlist(wishlist);
    updateWishlistCount();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);
  }

  function updateButtonState(button) {
    const productId = button.dataset.productId;
    const isInWishlist = Boolean(findItem(productId));

    button.classList.toggle('is-active', isInWishlist);
    button.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');

    const title = button.dataset.productTitle || 'this product';

    button.setAttribute(
      'aria-label',
      isInWishlist ? `Remove ${title} from wishlist` : `Save ${title}`
    );
  }

  function updateAllButtons() {
    document.querySelectorAll('.js-wishlist-button').forEach(updateButtonState);
  }

  function productFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice
    };
  }

  function handleButtonClick(event) {
    const button = event.target.closest('.js-wishlist-button');

    if (!button) return;

    const product = productFromButton(button);
    const exists = Boolean(findItem(product.id));

    if (exists) {
      removeItem(product.id);
    } else {
      addItem(product);
    }

    updateAllButtons();
    renderWishlistPage();
  }

  function getProductUrl(product) {
    return `/products/${product.handle}`;
  }

  function getProductImage(product, fallbackItem) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return fallbackItem.image || '';
  }

  function getDisplayOptionIndex(product) {
    if (!product.variants || !product.variants.length) return 0;

    const optionCount = product.options ? product.options.length : 1;

    for (let index = 0; index < optionCount; index += 1) {
      const values = new Set(
        product.variants.map((variant) => variant.options[index]).filter(Boolean)
      );

      if (values.size > 1) return index;
    }

    return 0;
  }

  function getVariantLabel(variant, optionIndex) {
    if (!variant.options || !variant.options.length) return variant.title;
    return variant.options[optionIndex] || variant.public_title || variant.title;
  }

  function getSelectedVariant(card) {
    const select = card.querySelector('.js-wishlist-variant-select');

    if (select) {
      const selectedOption = select.options[select.selectedIndex];

      return {
        id: Number(select.value),
        price: Number(selectedOption.dataset.price),
        compareAtPrice: selectedOption.dataset.compareAtPrice
          ? Number(selectedOption.dataset.compareAtPrice)
          : null,
        available: selectedOption.dataset.available === 'true'
      };
    }

    const button = card.querySelector('.js-wishlist-add-to-cart');

    if (!button || !button.dataset.variantId) return null;

    return {
      id: Number(button.dataset.variantId),
      price: Number(button.dataset.price),
      compareAtPrice: button.dataset.compareAtPrice
        ? Number(button.dataset.compareAtPrice)
        : null,
      available: button.dataset.available === 'true'
    };
  }

  function getPriceHtml(price, compareAtPrice) {
    if (compareAtPrice && compareAtPrice > price) {
      return `
        <span class="wishlist-card__compare-price">${formatMoney(compareAtPrice)}</span>
        <span class="wishlist-card__sale-price">${formatMoney(price)}</span>
      `;
    }

    return `<span class="wishlist-card__regular-price">${formatMoney(price)}</span>`;
  }

  function updateCardPrice(card) {
    const selectedVariant = getSelectedVariant(card);
    const priceEl = card.querySelector('.wishlist-card__price');
    const addButton = card.querySelector('.js-wishlist-add-to-cart');

    if (!selectedVariant || !priceEl) return;

    priceEl.innerHTML = getPriceHtml(selectedVariant.price, selectedVariant.compareAtPrice);

    if (addButton) {
      addButton.disabled = !selectedVariant.available;
      addButton.textContent = selectedVariant.available ? 'Add to Bag' : 'Sold Out';
    }
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) {
      throw new Error(`Could not fetch product: ${handle}`);
    }

    return response.json();
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');

      if (!response.ok) return;

      const cart = await response.json();
      const count = cart.item_count || 0;

      document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.classList.toggle('hidden', count === 0);

        if (count > 99) {
          badge.textContent = '(+)';
        } else if (count > 0) {
          badge.textContent = `(${count})`;
        } else {
          badge.textContent = '';
        }
      });
    } catch (error) {
      console.warn('Could not update cart count', error);
    }
  }

  async function refreshCartDrawer() {
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');

      if (!response.ok) return;

      const sections = await response.json();

      if (sections['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

        const newCartDrawer =
          doc.querySelector('.cart-drawer') ||
          doc.querySelector('#CartDrawer') ||
          doc.querySelector('cart-drawer');

        const currentCartDrawer =
          document.querySelector('.cart-drawer') ||
          document.querySelector('#CartDrawer') ||
          document.querySelector('cart-drawer');

        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }
      }

      if (sections['cart-icon-bubble']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');

        const newBubble =
          doc.querySelector('#cart-icon-bubble') ||
          doc.querySelector('.cart-count-bubble') ||
          doc.querySelector('[data-cart-count]');

        const currentBubble =
          document.querySelector('#cart-icon-bubble') ||
          document.querySelector('.cart-count-bubble') ||
          document.querySelector('[data-cart-count]');

        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      }
    } catch (error) {
      console.warn('Could not refresh cart drawer', error);
    }
  }

  function openCartDrawer() {
    const cartDrawer =
      document.querySelector('.cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer');

    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.classList.add('active');
      cartDrawer.classList.add('drawer--is-open');

      cartDrawer.setAttribute('open', '');
      cartDrawer.setAttribute('aria-hidden', 'false');

      document.body.classList.add('overflow-hidden');
      document.body.classList.add('cart-drawer-open');
    }

    const cartTrigger =
      document.querySelector('[data-cart-drawer-trigger]') ||
      document.querySelector('[data-cart-trigger]') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href="/cart"]');

    if (cartTrigger) {
      cartTrigger.click();
    }
  }

  function renderFallbackCard(item) {
    const card = document.createElement('article');
    card.className = 'wishlist-card';

    const imageHtml = item.image
      ? `
        <a href="${item.url}" class="wishlist-card__image-link">
          <img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy" class="wishlist-card__image">
        </a>
      `
      : '';

    card.innerHTML = `
      ${imageHtml}

      <div class="wishlist-card__content">
        <div class="wishlist-card__title-row">
          <h2 class="wishlist-card__title">
            <a href="${item.url}">${escapeHtml(item.title)}</a>
          </h2>

          <button
            type="button"
            class="wishlist-card__remove js-wishlist-remove"
            data-product-id="${item.id}"
            aria-label="Remove ${escapeHtml(item.title)} from wishlist"
          >
            Remove
          </button>
        </div>

        <p class="wishlist-card__price">${item.price || ''}</p>
      </div>
    `;

    return card;
  }

  function renderProductCard(product, item) {
    const card = document.createElement('article');
    const productUrl = getProductUrl(product);
    const image = getProductImage(product, item);
    const optionIndex = getDisplayOptionIndex(product);
    const variants = product.variants || [];
    const availableVariants = variants.filter((variant) => variant.available);
    const firstAvailableVariant = availableVariants[0] || variants[0];

    card.className = 'wishlist-card';

    const imageHtml = image
      ? `
        <a href="${productUrl}" class="wishlist-card__image-link">
          <img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" class="wishlist-card__image">
        </a>
      `
      : '';

    const variantOptionsHtml = variants.map((variant) => {
      const label = getVariantLabel(variant, optionIndex);
      const disabled = variant.available ? '' : 'disabled';
      const selected = firstAvailableVariant && variant.id === firstAvailableVariant.id ? 'selected' : '';

      return `
        <option
          value="${variant.id}"
          data-price="${variant.price}"
          data-compare-at-price="${variant.compare_at_price || ''}"
          data-available="${variant.available ? 'true' : 'false'}"
          ${disabled}
          ${selected}
        >
          ${escapeHtml(label)}${variant.available ? '' : ' — Sold Out'}
        </option>
      `;
    }).join('');

    const hasVariants = variants.length > 1;
    const initialPrice = firstAvailableVariant ? firstAvailableVariant.price : product.price;
    const initialCompareAtPrice = firstAvailableVariant
      ? firstAvailableVariant.compare_at_price
      : product.compare_at_price;
    const isAvailable = Boolean(firstAvailableVariant && firstAvailableVariant.available);

    card.innerHTML = `
      ${imageHtml}

      <div class="wishlist-card__content">
        <div class="wishlist-card__title-row">
          <h2 class="wishlist-card__title">
            <a href="${productUrl}">${escapeHtml(product.title)}</a>
          </h2>

          <button
            type="button"
            class="wishlist-card__remove js-wishlist-remove"
            data-product-id="${product.id}"
            aria-label="Remove ${escapeHtml(product.title)} from wishlist"
          >
            Remove
          </button>
        </div>

        <p class="wishlist-card__price">
          ${getPriceHtml(initialPrice, initialCompareAtPrice)}
        </p>

        <div class="wishlist-card__purchase">
          ${
            hasVariants
              ? `
                <select class="wishlist-card__variant-select js-wishlist-variant-select" aria-label="Choose size for ${escapeHtml(product.title)}">
                  ${variantOptionsHtml}
                </select>
              `
              : ''
          }

          <button
            type="button"
            class="wishlist-card__add-to-cart js-wishlist-add-to-cart"
            data-product-id="${product.id}"
            data-variant-id="${firstAvailableVariant ? firstAvailableVariant.id : ''}"
            data-price="${initialPrice || ''}"
            data-compare-at-price="${initialCompareAtPrice || ''}"
            data-available="${isAvailable ? 'true' : 'false'}"
            ${isAvailable ? '' : 'disabled'}
          >
            ${isAvailable ? 'Add to Bag' : 'Sold Out'}
          </button>
        </div>
      </div>
    `;

    return card;
  }

  async function renderWishlistPage() {
    const grid = document.querySelector('.js-wishlist-grid');
    const emptyState = document.querySelector('.js-wishlist-empty');

    if (!grid) return;

    const wishlist = getWishlist();

    grid.innerHTML = '';

    if (!wishlist.length) {
      if (emptyState) emptyState.hidden = false;
      grid.hidden = true;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    grid.hidden = false;

    wishlist.forEach((item) => {
      const loadingCard = document.createElement('article');
      loadingCard.className = 'wishlist-card wishlist-card--loading';
      loadingCard.innerHTML = '<p>Loading…</p>';
      grid.appendChild(loadingCard);

      fetchProduct(item.handle)
        .then((product) => {
          const card = renderProductCard(product, item);
          loadingCard.replaceWith(card);
        })
        .catch(() => {
          const fallbackCard = renderFallbackCard(item);
          loadingCard.replaceWith(fallbackCard);
        });
    });
  }

  function handleRemoveClick(event) {
    const button = event.target.closest('.js-wishlist-remove');

    if (!button) return;

    removeItem(button.dataset.productId);
    updateAllButtons();
    renderWishlistPage();
  }

  function handleVariantChange(event) {
    const select = event.target.closest('.js-wishlist-variant-select');

    if (!select) return;

    const card = select.closest('.wishlist-card');

    if (!card) return;

    updateCardPrice(card);
  }

  async function handleAddToCartClick(event) {
    const button = event.target.closest('.js-wishlist-add-to-cart');

    if (!button) return;

    const card = button.closest('.wishlist-card');
    const selectedVariant = getSelectedVariant(card);

    if (!selectedVariant || !selectedVariant.available) return;

    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: selectedVariant.id,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Could not add item to cart');
      }

      await response.json();

      button.textContent = 'Added';

      const productId = button.dataset.productId;

      await refreshCartDrawer();
      await updateCartCount();

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:change'));

      document.dispatchEvent(new CustomEvent('wishlist:cart:add', {
        detail: {
          variantId: selectedVariant.id,
          productId: productId
        }
      }));

      openCartDrawer();

      if (productId) {
        removeItem(productId);
        updateAllButtons();

        setTimeout(() => {
          renderWishlistPage();
        }, 500);
      }
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try Again';
    }
  }

  document.addEventListener('click', handleButtonClick);
  document.addEventListener('click', handleRemoveClick);
  document.addEventListener('change', handleVariantChange);
  document.addEventListener('click', handleAddToCartClick);

  document.addEventListener('DOMContentLoaded', function () {
    updateWishlistCount();
    updateAllButtons();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    updateWishlistCount();
    updateAllButtons();
    renderWishlistPage();
  });
})();